<template>
  <div>

    <section class="micarrito">

      <div class="container" >

        <div class="row" >

          <div class="col-lg-8">

            <div  class="box-producto-carrito" v-for="item in orderItems" :key="item.ID">
              <div class="box-image">
                <img :src="item.imageURL_M">
              </div>
              <div class="box-data">
                <h1>{{item.SINONIMO}} - {{item.DESCRIPCIO}}</h1>
                <div class="box-cantidad">
                  <div class="lbl">Cantidad</div>

                  <div class="value">
                    {{ item.QUANTITY }}
                  </div>

                </div>
                <div class="box-precio">
                  <div class="lbl">Precio Unitario</div>
                  <div class="value">{{item.UNIT_PRICE | currency}}</div>
                </div>
                <div class="box-precio" style="display:none;">
                  <div class="lbl">Precio Total</div>
                  <div class="value">{{item.UNIT_PRICE * item.QUANTITY | currency}}</div>
                </div>
              </div>

            </div>

          </div>

          <div class="col-lg-4" v-if="((loading===false))">

            <div class="box-resumen-compra">
              <h1>Tu Compra <i class="fa fa-shopping-cart pull-right"></i></h1>

              <div class="row">
                <div class="col-xs-6">
                  <div class="lbl">Cantidad Productos </div>
                </div>
                <div class="col-xs-6">
                  <div class="value">{{orderItems.length}}</div>
                </div>
              </div>


              <div class="spaceline"></div>

              <div class="row" style="display:none;">
                <div class="col-xs-6">
                  <div class="lbl">TOTAL </div>
                </div>
                <div class="col-xs-6">
                  <div class="value highlight">{{total | currency}}</div>
                </div>
              </div>

              <br><br>
            </div>

          </div>

        </div>

        <div class="row" v-if="((orderItems.length<0) && (loading===false))">
          <div class="col-lg-12">

            <div class="box-noproducts">
              <h1>No hay productos en la orden.</h1>
              <router-link to="/" class="btn-submit">COMENZAR</router-link>
            </div>

          </div>
        </div>

        <div class="row" v-if="((loading===true))">
          <div class="col-lg-12">

            <div class="box-noproducts">
              <h1>Cargando Detalle</h1>
            </div>

          </div>
        </div>

      </div>

    </section>
  </div>
</template>

<script>
import Api from '@/Api'
import { mapGetters } from 'vuex';
import {baseUrl} from "../Api";

export default {
  data(){
    return {
      loading:true,
      orderItems:[]
    }
  },
  computed: {
    ...mapGetters(['user','isLogged','cart_total','cart_subtotal', 'discount_value','purchaseMin','shipment','payment']),
    total(){
      if (this.orderItems.length>0){
        return this.orderItems.reduce( (acum,item) => {
          return acum + (item.UNIT_PRICE * item.QUANTITY);
        },0)
      }
      return 0;

    }
  },
  methods:{

  },
  mounted(){

    window.scrollTo(0, 0);

    Api().get('order/' + this.$route.params.id).then(data=>{ // +user.user_id
      this.loading = false;
      if (data.data.status===1){
        //this.orderItems = data.data.payload;
        data.data.data.forEach(value => {
          value.imageURL_M = baseUrl + "/" + value.imageURL_M;
          this.orderItems.push(value);
        });
      }else{
        this.orderItems = [];
      }

    }).catch(err=>{

    });
  }
}
</script>

<style scoped>
.inputForm{
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyOrderDetailPage.vue